import { ExpandableAddressSearch } from "../../common/maps/ExpandableAddressSearch";
import MyLocationToolbarButton from "../../common/maps/MyLocationToolbarButton";
import { SelectionToolbar } from "../../neighborhoodSearch/components/SelectionToolbar";
import { GeoLocation } from "../../../types/common";
import { usePulse, pulseClassName } from "src/hooks/usePulse";

interface SearchToolbarProps {
  onAddressSelected?: (data: {address: any, location: GeoLocation, formattedAddress: string, smartyStreetAddress: any}) => void;
  onLocationRequest?: (location: GeoLocation) => void;
  drawingMode?: string | null;
  selectedShapeType?: string | null;
  onDrawingModeChange?: (mode: string | null) => void;
  triggerPulse?: boolean;
  enableSelectionToolbar?: boolean;
  enableMyLocationButton?: boolean;
}

export const SearchToolbar = ({
  onAddressSelected,
  onLocationRequest,
  drawingMode,
  selectedShapeType,
  onDrawingModeChange,
  triggerPulse = false,
  enableSelectionToolbar = false,
  enableMyLocationButton = false,
}: SearchToolbarProps) => {
  const isPulsing = usePulse(triggerPulse);

  return (
    <div className={`relative bg-white rounded-md border border-input shadow-sm p-2 ${pulseClassName(isPulsing)}`}>
      <div className="map-search-toolbar flex flex-col gap-2 justify-center">
        {/* Map Controls */}
        <div className="flex items-center gap-2">
        {/* Address Search */}
        <ExpandableAddressSearch
          onAddressSelected={({ address, location, formattedAddress, smartyStreetAddress }) => {
            onAddressSelected?.({ address, location, formattedAddress, smartyStreetAddress });
          }}
          onLocationChange={(location) => {
            onLocationRequest?.(location);
          }}
          onAddressCleared={() => {
            // Handle address clearing if needed
          }}
          isCondensed={true}
        />
        {enableMyLocationButton && (
          <MyLocationToolbarButton
            onClick={(location) => onLocationRequest?.(location)}
            className="bg-white"
          />
        )}
        {enableSelectionToolbar && (
          <SelectionToolbar
            drawingMode={(selectedShapeType ?? drawingMode) ?? ""}
            onDrawingModeChange={(mode) => onDrawingModeChange?.(mode)}
          />
        )}
        </div>
      </div>
    </div>
  );
};